module.exports = {"plate":{"semi":"Semi","material":"Material","surface":"Surface","thickness":"Thickness","drawingNo":"Drawing No.","rev":"Revision"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/plate.json
// module id = 919
// module chunks = 108